export default "__VITE_ASSET__CNebvcMB__"